
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Box, Card, CardContent, Collapse, TextField, Typography } from '@mui/material';
import Fuse from 'fuse.js';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useSearchParams } from 'react-router-dom';
import { Title } from '../../common/title/Title';

export const Help = () => {

  const [query, setQuery] = useState('');
  const [expanded, setExpanded] = useState(null); // Track which card is expanded
  const [helpData, setHelpData] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchParams] = useSearchParams();
  const entity = searchParams.get('entity'); // Optional entity in URL

  /*
  * Retrieve all topics from each module in application
  */
  const rsrc = useRsrc();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await rsrc.help('admin'); // WIP talked to Casey about AI Help
        setHelpData(Array.isArray(data) ? data : []);
      } catch (error) {
        setHelpData([]);
      }
    };
    fetchData();
  }, []);

  /*
  * Filter results based on search bar
  */
  useEffect(() => {

    const fuse = new Fuse(helpData, {
      keys: ['question', 'answer'],  // Fields to search in
      threshold: 0.3,              // Controls how fuzzy the search is (lower = more strict)
    });

    if (!query && entity) {
      setFilteredResults(fuse.search(entity).map((result) => result.item));
      return;
    }

    setFilteredResults(fuse.search(query).map((result) => result.item));
  }, [query, helpData]);


  return (
    <>
      {/* Title */}
      <Title icon={fas.faCircleQuestion} title="Help Center"></Title>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
        padding: '20px',
      }}>

        {/* Search Bar */}
        <TextField
          fullWidth
          placeholder="Search help topics..."
          variant="outlined"
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          sx={{
            maxWidth: '500px',
            borderRadius: '50px',
            backgroundColor: '#fff',
            '& .MuiOutlinedInput-root': {
              borderRadius: '50px',
              boxShadow: '2px 2px 8px rgba(0, 0, 0, 0.1)',
              '&:hover fieldset': { borderColor: '#007bff' },
              '&.Mui-focused fieldset': { borderColor: '#007bff', boxShadow: '0 0 10px rgba(0, 123, 255, 0.3)' },
            },
          }}
        />

        {!query && entity &&
          <Typography sx={{ textAlign: 'center', color: '#777', mt: 2 }}>
            Suggested questions...
          </Typography>
        }

        {/* Search Results */}
        <Box sx={{ width: { xs: '90%', sm: '60%', md: '50%' }, mt: 2 }}>
          {filteredResults.length > 0 ? (
            filteredResults.map((item) => (
              <Card
                key={item.id}
                sx={{
                  borderRadius: '10px',
                  boxShadow: '2px 2px 10px rgba(0, 0, 0, 0.1)',
                  transition: '0.3s',
                  '&:hover': { boxShadow: '0px 4px 20px rgba(0, 123, 255, 0.3)' },
                  cursor: 'pointer',
                }}
                onClick={() => setExpanded(expanded === item.question ? null : item.question)} // Toggle expand
              >
                <CardContent>
                  <Typography>
                    {item.question}
                  </Typography>
                  <Collapse in={expanded === item.question} timeout="auto" unmountOnExit>
                    <Box sx={{ mt: 2 }}>
                      <ReactMarkdown components={{ p: Typography }}>{item.answer}</ReactMarkdown>
                    </Box>
                  </Collapse>
                </CardContent>
              </Card>
            ))
          ) : (
            query && (
              <Typography sx={{ textAlign: 'center', color: '#777', mt: 2 }}>
                No results found
              </Typography>
            )
          )}
        </Box>
      </Box>
    </>
  );
}